import { Action } from 'redux';
import { SnackbarKey } from 'notistack';
import { LocationState } from 'history';

import { IAlert, ILayoutInfo, INotificationOptions } from 'core/redux/reducers/layout/type';


export enum TypesLayout {
  LOGIN = 'layout.LOGIN',
  LOGOUT = 'layout.LOGOUT',
  REDIRECT = 'layout.REDIRECT',
  PROGRESS_START = 'layout.PROGRESS_START',
  PROGRESS_END = 'layout.PROGRESS_END',
  SET_IS_SUCCESS = 'layout.SET_IS_SUCCESS',
  SET_MESSAGE = 'layout.SET_MESSAGE',
  ENQUEUE_SNACKBAR = 'layout.ENQUEUE_SNACKBAR',
  CLOSE_SNACKBAR = 'layout.CLOSE_SNACKBAR',
  REMOVE_SNACKBAR = 'layout.REMOVE_SNACKBAR',
  GET_LAYOUT_INFO_REQUEST = 'layout.GET_LAYOUT_INFO_REQUEST',
  GET_LAYOUT_INFO_SUCCESS = 'layout.GET_LAYOUT_INFO_SUCCESS',
  SET_ALERT = 'layout.SET_ALERT',
  REMOVE_ALERT = 'layout.REMOVE_ALERT',
}

export type ILoginAction = () => Action<TypesLayout.LOGIN> & {
  token: string;
};

export type ILogoutAction = () => Action<TypesLayout.LOGOUT>;

export type IRedirectAction = () => Action<TypesLayout.REDIRECT> & {
  url: string;
  state?: LocationState;
};

export type IProgressStartAction = (
  url: string,
  isModal?: boolean
) => Action<TypesLayout.PROGRESS_START> & { url: string; isModal?: boolean };

export type IProgressEndAction = (
  url: string,
  isModal?: boolean
) => Action<TypesLayout.PROGRESS_END> & { url: string; isModal?: boolean };

// export type ISetIsSuccessAction = (
//   isSuccess: boolean
// ) => Action<TypesLayout.SET_IS_SUCCESS> & { isSuccess: boolean };
//
// export type ISetMessageAction = (
//   message: string
// ) => Action<TypesLayout.SET_MESSAGE> & { message: string };

export type IEnqueueSnackbarAction = (
  notification: INotificationOptions
) => Action<TypesLayout.ENQUEUE_SNACKBAR> & {
  notification: INotificationOptions & { key: SnackbarKey };
};

export type ICloseSnackbarAction = (
  key: SnackbarKey
) => Action<TypesLayout.CLOSE_SNACKBAR> & { dismissAll: boolean; key: SnackbarKey };

export type IRemoveSnackbarAction = (
  key: SnackbarKey
) => Action<TypesLayout.REMOVE_SNACKBAR> & { key: SnackbarKey };

export type IGetLayoutInfoRequestAction = () => Action<TypesLayout.GET_LAYOUT_INFO_REQUEST>;

export type IGetLayoutInfoSuccessAction = () => Action<TypesLayout.GET_LAYOUT_INFO_SUCCESS> & {
  data: ILayoutInfo;
};

export type ISetAlertAction = () => Action<TypesLayout.SET_ALERT> & {
  alert: IAlert;
};
export type IRemoveAlertAction = () => Action<TypesLayout.REMOVE_ALERT> & {
  alertId: number
};

export type ActionsLayout = ReturnType<
  | ILoginAction
  | ILogoutAction
  | IRedirectAction
  | IProgressStartAction
  | IProgressEndAction
  // | ISetIsSuccessAction
  // | ISetMessageAction
  | IEnqueueSnackbarAction
  | ICloseSnackbarAction
  | IRemoveSnackbarAction
  | IGetLayoutInfoRequestAction
  | IGetLayoutInfoSuccessAction
  | ISetAlertAction
  | IRemoveAlertAction
>;
